import {
  BEGIN_FETCH_DATA,
  FINISH_FETCH_DATA,
  SAVE_CONTENT_REQUEST,
  SAVE_CONTENT_SUCCESS,
  SAVE_STATE
} from './constant';

const initState = {
  isLoading: false,
  isSaving: false,
  undoStack: { position: null, stack: [] }
};

export default (state = initState, action) => {
  switch (action.type) {
    case BEGIN_FETCH_DATA:
      return { ...state, isLoading: true };
    case FINISH_FETCH_DATA:
      return { ...state, isLoading: false };
    case SAVE_STATE:
      return Object.assign({}, state, { undoStack: action.payload });
    case SAVE_CONTENT_REQUEST:
      return { ...state, isSaving: true };
    case SAVE_CONTENT_SUCCESS:
      return { ...state, isSaving: false };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/containers/content/reducer.js